import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import Icon from 'components/Icon';
import CastMember from '../CastMember';
import Style from './CastSlider.module.scss';

const PrevArrow = ({ className, onClick }) => (
  <button
    className={classNames(className, Style.prevArrow)}
    onClick={onClick}
    type="button"
    data-role="none"
    aria-label="show previous content"
  >
    <Icon color="white" viewBox="0 0 43 44" icon="carousel-arrow-left" />
  </button>
);

PrevArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

const NextArrow = ({ className, onClick }) => (
  <button
    className={classNames(className, Style.nextArrow)}
    onClick={onClick}
    type="button"
    aria-label="show next content"
    data-role="none"
  >
    <Icon color="white" viewBox="0 0 43 44" icon="carousel-arrow-right" />
  </button>
);

NextArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

const settings = {
  speed: 500,
  infinite: false,
  slidesToShow: 10,
  slidesToScroll: 10,
  initialSlide: 0,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
      },
    },
    {
      breakpoint: 1439,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
      },
    },
    {
      breakpoint: 2559,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
      },
    },
    {
      breakpoint: 2560,
      settings: {
        slidesToShow: 10,
        slidesToScroll: 10,
      },
    },
  ],
};

const CastSlider = ({ castArray, setCastDetail, disableScroll, breakpoint }) => {
  const castMembers = castArray.map((castMember, index) => (
    <CastMember
      key={castMember.id}
      info={castMember}
      index={index}
      setCastDetail={setCastDetail}
      disableScroll={disableScroll}
      breakpoint={breakpoint}
      opensOverlay
    />
  ));

  return (
    <>
      <div className={Style.desktopCast}>
        <Slider {...settings}>{castMembers}</Slider>
      </div>
      <div className={Style.mobileCast}>{castMembers}</div>
    </>
  );
};

CastSlider.propTypes = {
  breakpoint: PropTypes.string,
  castArray: PropTypes.arrayOf(PropTypes.shape({})),
  setCastDetail: PropTypes.func,
  disableScroll: PropTypes.func,
};

export default CastSlider;
